// getters: son para traer información del state
// no son asíncronos usualmente
export const hits = ( state ) => state.hits

export const errors = ( state ) => state.errors